/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import { useFetchAppInfo } from "@/apis/queryFunctions/appInfo";
import { fetchCategories } from "@/apis/queryFunctions/categoryFunctions";
import { postContact } from "@/apis/queryFunctions/contact";
import {
  fetchEcompage,
  useFetchEcompage,
} from "@/apis/queryFunctions/ecompagesFunctions";
import { categoryKeys, ecompagesKeys } from "@/apis/queryKeys";
import Container from "@/common/Layout/Container/Container";
import DefaultSEO from "@/common/components/DefaultSEO";
import useTrans from "@/hooks/useTrans";
import { useLocalContext } from "@/setup/locale-provider";
import { appAlert } from "@/setup/mantine-provider/notifications";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";
import {
  BackgroundImage,
  Box,
  Button,

  Card,
  Center,
  Grid,
  Group,
  MediaQuery,
  // Group,
  NavLink,
  // Select,
  // Text,
  Overlay,
  ScrollArea,
  Skeleton,
  Text,
  TextInput,
  Textarea,
  Title
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { QueryClient, dehydrate, useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import React from "react";

export default function LienHe({ dataSEO }) {
  const { getLabel } = useLocalContext();
  const trans = useTrans();
  const { locale } = useRouter();
  const { data: detail } = useFetchEcompage("trang-lien-he-viet-thien", locale);
  const { data: appInfo } = useFetchAppInfo({});
  /* const { data } = useFetchEcompage("trang-lien-he", locale);
  const pictureVT = data?.add_on_data_3[0]||{}; */

  // console.log("detail", detail);
  console.log("update_88")

  const [value, setValue] = React.useState(0);

  const form = useForm({
    initialValues: {
      ho_ten: "",
      dien_thoai: "",
      email: "",
      dia_chi: "",
      noi_dung: "",
    },
    validate: {
      ho_ten: (value) =>
        value.length > 0 ? null : "Vui lòng nhập họ tên của quý khách",
      email: (value) =>
        value.length > 0
          ? /^\S+@\S+$/.test(value)
            ? null
            : "Email không hợp lệ"
          : "Vui lòng nhập email để cửa hàng liên hệ với quý khách",
      // dien_thoai: (value) =>
      //   value.length > 0
      //     ? /^(0|\+84)(\s|\.)?((3[2-9])|(5[689])|(7[06-9])|(8[1-689])|(9[0-46-9]))(\d)(\s|\.)?(\d{3})(\s|\.)?(\d{3})$/.test(
      //         value
      //       )
      //       ? null
      //       : "Số điện thoại không hợp lệ"
      //     : "Vui lòng nhập số điện thoại của quý khách",
      noi_dung: (value) => (value.length > 0 ? null : "Vui lòng nhập nội dung"),
    },
  });

  const contactMutation = useMutation(postContact, {
    onSuccess: (rs) => {
      if (rs._id) {
        appAlert({ type: "success", message: "Gửi thông tin thành công" });
      } else {
        appAlert({ message: "Gửi thông tin không thành công" });
      }
      form.reset();
    },
  });

  const handleSubmit = () => {
    contactMutation.mutate({ ...form.values });
  };

  return (
    <div>
      <DefaultSEO seo={dataSEO} />
      <div>

        <Container size="xl" /* sx={{background:"pink"}} */>
          <Box py={20}>
        
            <Grid  grow gutter={70}/* style={{ width: "100%", margin: 0 }} */ justify="space-between">
            <Grid.Col xs={12} sm={5}>
              {/* <Box > */}
                
                <BackgroundImage
                  src={appendImageUrlFromAPI({src:detail?.add_on_data_3?.[0]?.picture})}
                  style={{
                    backgroundSize:"cover",
                    height:"610px",
                    borderRadius:"20px"
                  }}
                 
                >  
                  <div
                    style={{
                      background: "linear-gradient(360deg, rgba(18, 133, 79, 0.80) 30%, rgba(18, 133, 79, 0.00) 50%)" ,
                      width: "100%",
                      height: "100%",
                      borderRadius: "20px",
                      
                      /* opacity: 0.5, */
                    }}
                  >

                
                  <Center p="lg">
                  <Box>
                  {/* <Title order={1} size="h4" color="#FFF">
                    {locale === "vi" ? appInfo?.name : appInfo?.name_en}
                  </Title> */}
                  <Box pt={450}>
                    {/* <Text mb={8} color="#FFF">
                      <b>{trans?.contact.taxCodeLabel}: </b>
                      {appInfo?.ma_so_thue}
                    </Text> */}
                    {Boolean(detail) &&
                      detail?.add_on_data_2
                        ?.filter((el) => el.shared)
                        ?.map((item, index) => (
                          <Text mb={8} key={index} color="#FFF">
                            <b>{item?.title} </b>
                            {item?.summary}
                          </Text>
                        ))}
                    <Text mb={8} color="#FFF">
                      <b>{trans?.contact.email}: </b> {appInfo?.email}
                    </Text>
                    <Text mb={8} color="#FFF">
                      <b>{trans?.contact.address}: </b>
                      {locale === "vi" ? appInfo?.address : appInfo?.address_en}
                    </Text>
                  </Box>
                </Box>
                </Center>
                </div>
                </BackgroundImage>
              {/* </Box> */}
              </Grid.Col>


              <Grid.Col xs={12} sm={6}>
                <Card shadow="sm" p="lg" radius="md" withBorder>
                  <MediaQuery smallerThan="md" order={4}>
                    <Title className="webview" order={1} size="h4" align="justify" color="#12854F" weight={950} size={36}>
                      {trans?.contact.form.title}
                    </Title>
                  </MediaQuery>
                  <Text mb={10}>{trans?.contact.content}</Text>
                  <form onSubmit={form.onSubmit(handleSubmit)}>
                    <TextInput
                      label={trans?.contact.form.fullName}
                      withAsterisk
                      size="sm"
                      placeholder={trans?.contact.placeholder.fullName}
                      {...form.getInputProps("ho_ten")}
                      mb={12}
                    />
                    <TextInput
                      label={trans?.contact.form.phone}
                      size="sm"
                      placeholder={trans?.contact.placeholder.phone}
                      {...form.getInputProps("dien_thoai")}
                      mb={12}
                    />
                    <TextInput
                      label={trans?.contact.form.email}
                      withAsterisk
                      size="sm"
                      placeholder={trans?.contact.placeholder.email}
                      {...form.getInputProps("email")}
                      mb={12}
                    />
                    <TextInput
                      label={trans?.contact.form.address}
                      size="sm"
                      placeholder={trans?.contact.placeholder.address}
                      {...form.getInputProps("dia_chi")}
                      mb={12}
                    />
                    <Textarea
                      placeholder={trans?.contact.placeholder.content}
                      withAsterisk
                      label={trans?.contact.form.content}
                      size="sm"
                      autosize
                      minRows={2}
                      maxRows={2}
                      {...form.getInputProps("noi_dung")}
                    />
                    <Group position="center">
                      <Button
                        type="submit"
                        h={40}
                        fullWidth
                        variant="filled"
                        bg="12854F"
                        radius="xl"
                        style={{margin:"25px 0 10px 0"}}
                        
                      >
                        <Text weight="500" transform="uppercase">
                          {trans?.contact.form.button}
                        </Text>
                      </Button>
                    </Group>
                  </form>
                </Card>
              </Grid.Col>
            </Grid>
            
          </Box>
          <Box py={20}>
            <Center>
              <MediaQuery smallerThan="md" order={4}>
                <Title order={1} size="h4">
                  {trans?.contact.map.title.toUpperCase()}
                </Title>
              </MediaQuery>
            </Center>
            <Skeleton visible={!detail}>
              <Box pt={20} sx={{ minHeight: 470 }}>
                <Grid>
                  <Grid.Col xs={12} md={6}>
                    <MediaQuery smallerThan="md" styles={{ height: 250 }}>
                      <ScrollArea>
                        {Boolean(detail) &&
                          detail?.add_on_data &&
                          detail?.add_on_data
                            ?.filter((el) => el.shared)
                            ?.map((item, i) => (
                              <NavLink
                                key={i}
                                label={getLabel(item.title)}
                                description={getLabel(item.summary)}
                                onClick={() => setValue(i)}
                                active={i === value}
                                styles={{
                                  label: {
                                    fontSize: 16,
                                    fontWeight: 700,
                                  },
                                }}
                              />
                            ))}
                      </ScrollArea>
                    </MediaQuery>
                  </Grid.Col>
                  <Grid.Col
                    sx={{
                      padding: 0,
                      paddingTop: 8,
                    }}
                    xs={12}
                    md={6}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: detail?.add_on_data?.[value]?.content,
                      }}
                    />
                  </Grid.Col>
                </Grid>
              </Box>
            </Skeleton>
          </Box>
        </Container>
      </div>
    </div>
  );
}

// export async function getStaticProps({ locale }) {
//   // const queryClient = new QueryClient();

//   // await queryClient.prefetchQuery(ecompagesKeys.detail('trang-lien-he'), () => fetchEcompage('trang-lien-he', locale))

//   // const seoData = await fetchEcompage("trang-lien-he", locale);

//   const pageName = "trang-lien-he-viet-thien";
//   const { queryClient, dataSEO } = await ensureQuerySeoPage(pageName, locale);
//   await queryClient.prefetchQuery(ecompagesKeys.detail("du-lieu-chung-viet-thien"), () =>
//     fetchEcompage("du-lieu-chung-viet-thien", locale)
//   );

//   return {
//     props: {
//       dehydratedState: dehydrate(queryClient),
//       dataSEO: { ...dataSEO },
//     },
//     revalidate: 60,
//   };
// }

export async function getStaticProps({ locale }) {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery(ecompagesKeys.detail("trang-lien-he-viet-thien"), () =>
    fetchEcompage("trang-lien-he-viet-thien", locale)
  );
  await queryClient.prefetchQuery(categoryKeys.all, () => fetchCategories({condition: {highlight: true}}))

  const seoData = await fetchEcompage("trang-lien-he-viet-thien", locale); 

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      dataSEO: {
        title: seoData?.meta_title || "Nông sản Việt Thiên - Nông sản Việt vươn xa",
        description: seoData?.meta_description || null,
        keywords: seoData?.meta_keywords || null,
        picture1: seoData?.meta_picture_1 || null,
        picture2: seoData?.meta_picture_2 || null,
      },
    },
    revalidate: 60,
  };
}
